import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';

const getAllPhoneNumberGroups = (orgid) => {
    return AxiosInstance.get(`${Config.API_URL}/api/PhoneNumberGroup/${orgid}`);
}

const createPhoneNumberGroup = (data) => {
    return AxiosInstance.post(`${Config.API_URL}/api/PhoneNumberGroup`, data);
}

const updatePhoneNumberGroup = (data)=>{
    return AxiosInstance.put(`${Config.API_URL}/api/PhoneNumberGroup`, data);
}

const deletePhoneNumberGroup = (orgid,groupid) =>{
    return AxiosInstance.delete(`${Config.API_URL}/api/PhoneNumberGroup/${orgid}/${groupid}`);
}

const getGridByOrganizations = (data)=>{
        return AxiosInstance.post(`${Config.API_URL}/api/PhoneNumberGroup/phonegroupsByOrganizations`,data);

}

export const PhoneNumberGroupService = {
getAllPhoneNumberGroups,
createPhoneNumberGroup,
updatePhoneNumberGroup,
deletePhoneNumberGroup,
getGridByOrganizations,

}